module.exports = __webpack_public_path__ + "img/newlogo.8ff34409.png";